import { DSButtonIcon, DSNCLinkedButtons } from 'shared-definitions/types'
import { ApiComponentButtons } from '../types.wp'
import { parseColor } from 'shared-code/util'
import { pLinkExternalMapper } from './pLinkMapper'

export function ncLinkedButtons(input: ApiComponentButtons): DSNCLinkedButtons {
  return {
    resource: 'nc-linked-buttons',
    buttons: input.list.map(item => {
      const icon = item.icon ? /(\w+)\.svg$/.exec(item.icon) : null
      return {
        label: item.text,
        pLink: item.nofollow ? pLinkExternalMapper(item.url) : { href: item.url },
        align: 'center',
        icon: icon ? (icon[1] as DSButtonIcon) : null,
        color: item.color ? parseColor(item.color) : null,
      }
    }),
  }
}
